import { useAtomValue } from 'jotai';
import PopupInfoEl from '../popup-info-el';
import { getPopupLocationCoordinatesAtom } from '../../job-explorer-map.atoms';
import { useCombinedClusters } from './use-cluster';
import { jobExplorerPageContentAtom } from '../../job-explorer-filters.atoms';

export const JobPositionAndRestaurantPins = () => {
  const popupLocationCoordinates = useAtomValue(getPopupLocationCoordinatesAtom);
  const jobExplorerPageContent = useAtomValue(jobExplorerPageContentAtom);
  const combinedClusterMarkers = useCombinedClusters(
    jobExplorerPageContent === 'only-jps' ? 'job-positions' : undefined
  );

  return (
    <>
      {combinedClusterMarkers}
      {!!popupLocationCoordinates?.id && (
        <div className="md:hidden absolute bottom-[10%] md:relative md:bottom-[unset] w-full flex justify-center">
          <PopupInfoEl />
        </div>
      )}
    </>
  );
};
